// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hashtag-feed {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 16px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 16px;
  gap: 16px;
}

.loading-text {
  color: var(--text-secondary);
  font-size: 16px;
  margin: 0;
}

.hashtag-header {
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-color);
}

.hashtag-header h1 {
  margin: 0 0 8px 0;
  color: var(--primary-color);
  font-size: 28px;
}

.post-count {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
}

.filter-controls {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  justify-content: center;
}

.filter-btn {
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  background: var(--bg-secondary);
  color: var(--text-primary);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
}

.filter-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.filter-btn.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.posts-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.error-message {
  background: var(--error-bg, rgba(255, 0, 0, 0.1));
  color: var(--error-color, #d32f2f);
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
}

.no-posts {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary);
  font-size: 16px;
}

.no-posts p {
  margin: 0;
}

.hashtag-load-more {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.hashtag-load-more-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 22px;
  background: var(--primary-color);
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}

.hashtag-load-more-btn:disabled {
  opacity: 0.7;
  cursor: default;
}

.hashtag-end-message {
  text-align: center;
  color: var(--text-secondary);
  font-size: 14px;
  margin-top: 24px;
}

.hashtag-end-message p {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HashtagFeed.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iDAAiD;EACjD,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".hashtag-feed {\r\n  width: 100%;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  padding: 16px;\r\n}\r\n\r\n.loading-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 16px;\r\n  gap: 16px;\r\n}\r\n\r\n.loading-text {\r\n  color: var(--text-secondary);\r\n  font-size: 16px;\r\n  margin: 0;\r\n}\r\n\r\n.hashtag-header {\r\n  text-align: center;\r\n  margin-bottom: 24px;\r\n  padding-bottom: 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.hashtag-header h1 {\r\n  margin: 0 0 8px 0;\r\n  color: var(--primary-color);\r\n  font-size: 28px;\r\n}\r\n\r\n.post-count {\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n}\r\n\r\n.filter-controls {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 24px;\r\n  justify-content: center;\r\n}\r\n\r\n.filter-btn {\r\n  padding: 8px 16px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.filter-btn:hover {\r\n  border-color: var(--primary-color);\r\n  color: var(--primary-color);\r\n}\r\n\r\n.filter-btn.active {\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.posts-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.error-message {\r\n  background: var(--error-bg, rgba(255, 0, 0, 0.1));\r\n  color: var(--error-color, #d32f2f);\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  margin-bottom: 16px;\r\n  font-size: 14px;\r\n}\r\n\r\n.no-posts {\r\n  text-align: center;\r\n  padding: 32px 16px;\r\n  color: var(--text-secondary);\r\n  font-size: 16px;\r\n}\r\n\r\n.no-posts p {\r\n  margin: 0;\r\n}\r\n\r\n.hashtag-load-more {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 24px;\r\n}\r\n\r\n.hashtag-load-more-btn {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 22px;\r\n  background: var(--primary-color);\r\n  color: #fff;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.hashtag-load-more-btn:disabled {\r\n  opacity: 0.7;\r\n  cursor: default;\r\n}\r\n\r\n.hashtag-end-message {\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  margin-top: 24px;\r\n}\r\n\r\n.hashtag-end-message p {\r\n  margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
